<template>
  <div class="footer-box">


  <van-tabbar v-model="type" @change="onChange" active-color="#037AFE" inactive-color="#999" style="height: 1.4rem;background: transparent;box-sizing: border-box; z-index: 200">

    <van-tabbar-item>
      <span class="foot-text">{{ $t('客服') }}</span>
      <template #icon="props">
       <img :class="{no:!props.active}" :src="props.active ? '/static/image/new/tabbar/tab1-active.png' : '/static/image/new/tabbar/tab1.png'" />
    </template>
    </van-tabbar-item>

    <van-tabbar-item>
      <span class="foot-text">{{ $t('大厅') }}</span>
      <template #icon="props">
        <img :class="{no:!props.active}" :src="props.active ? '/static/image/new/tabbar/tab2-active.png' : '/static/image/new/tabbar/tab2.png'" />
      </template>
    </van-tabbar-item>

    <van-tabbar-item>
      <span class="foot-text">{{ $t('发现') }}</span>
      <template #icon="props">
        <img :class="{no:!props.active}" :src="props.active ? '/static/image/new/tabbar/tab3-active.png' : '/static/image/new/tabbar/tab3.png'" />
      </template>
    </van-tabbar-item>

    <van-tabbar-item>
      <span class="foot-text">{{ $t('优惠') }}</span>
      <template #icon="props">
        <img :class="{no:!props.active}" :src="props.active ? '/static/image/new/tabbar/tab4-active.png' : '/static/image/new/tabbar/tab4.png'" />
      </template>
    </van-tabbar-item>


    <van-tabbar-item>
      <span class="foot-text">{{ $t('我的') }}</span>
      <template #icon="props">
        <img :class="{no:!props.active}" :src="props.active ? '/static/image/new/tabbar/tab5-active.png' : '/static/image/new/tabbar/tab5.png'" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
  <!-- <div class="colosline"></div> -->
</div>
</template>
<script>
//
export default {
  name: 'Foot',
  data() {
    return {
      type: 0,
    };
  },
  methods: {
    onChange(type) {
      let that = this;
      if (type == 0) {
        that.$parent.goNav(`/dialogue`);
      }
      if (type == 1) {
        // that.$parent.goNav(`/activity`);
        that.$parent.goNav(`/home`);
      }
      if (type == 2) {
        // that.$parent.openKefu();
        that.$parent.goNav(`/discover`);
      }
      if (type == 3) {
        that.$parent.goNav(`/activity`);

        // that.$parent.goNav(`/zhanzhu`);
      }
      if (type == 4) {
        that.$parent.goNav(`/mine`);
        // that.$parent.goNav(`/mine`);
      }
    },
    changPath() {
      let that = this;
      let path = this.$route.path;
      if (path == '/dialogue') {
        that.type = 0;
      }
      if (path == '/home' || path == '/') {
        that.type = 1;
      }if (path == '/discover') {
        that.type = 2;
      }

      if (path == '/activity') {
        that.type = 3;
      }
      if (path == '/mine') {
        that.type = 4;
      }
      // if (path == '/mine') {
      //   that.type = 4;
      // }
      // if (path == '/gamePage' || path == '/hongbao') {
      //   that.type = 5;
      // }
    },
  },
  mounted() {
  },
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.changPath();
      },
    },
  },
};
</script>
<style lang="scss">
.van-tabbar-item__text {
  width: 100% !important;
}
[class*=van-hairline]:after {
  opacity: 0;
  border: none;
}
</style>
<style lang="scss" scoped>
// @import '../../../static/css/chunk-611499bd.2ebefcf0.css';
.van-tabbar-item__icon img {
  display: block;
  height: 20px;
  margin-bottom: 6px;
}

.van-tabbar-item__icon .no{
  height: 20px;
  margin-bottom: 6px;
}
.van-tabbar-item {
  font-size: 14px;
  width: calc(100% / 5);
}

.van-tabbar {
  height: 1.6rem;
}
.van-tabbar-item--active {
  background-color: transparent;
}
.colosline{
    width: 100%;
    height: 2px;
    // background: -webkit-linear-gradient(left, #f08448, #ffce70, #f08449);
    background: linear-gradient(90deg, #f08448, #ffce70, #f08449);
}
.footer-box{
  font-family: PingFang SC;
  height: 1.79rem;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 300;
  flex-shrink: 0;
  background: #26292E;
  .van-tabbar--fixed {
    position: relative !important;
  }
  .foot-text {
    width: 100%;
    font-size: .27rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; //强制不换行
    display: inline-block;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/libs/Foot.vue